import { appHandlerUtils } from '@wartek-id/toolbox-helper'

export default appHandlerUtils.androidHandler
export const androidHandler = appHandlerUtils.androidHandler
export const createAndroidAuthDataCallback =
  appHandlerUtils.createAndroidAuthDataCallback
